export const deleteShipmentVisitEndpoint = (shipmentUid: string, visitId: string) =>
  `/shipments/${shipmentUid}/visits/${visitId}`
